export default {
  data: () => ({
        
    canvasForm: null,
    canvasContents: null,
    rawData:    null,
    filterData: null,

    revision:   null,
    area:       null,
    table:      null,
    columns:    null,
    scroll:     null,
  }),


  computed: {
    ready2draw() {
      return (
        this.DataItems.length > 0 &&
        Object.keys(this.Canvas).length > 0
      )
    },
  },


  methods: {
    set_Gradients() {

      
    },

  }
}